import { BASE_URL } from "../../config";
import { SET_ERROR_STATE, RESET_STATUS_STATE, REQUEST_STATE, SET_SUCCESS_STATE } from "../../utils/constants/actionTypes";
import { get_token_cif } from "../../config/api";
import bugsnagClient from "../../config/bugsnag";
import store from "..";

export default ({ ClientID, tokenCIF }, cb) =>
	async (dispatch) => {
		dispatch({ type: "REQUEST_LP" });
		// console.log({tokenCIF});
		try {
			if (tokenCIF) {
				let payload = await JSON.parse(atob(tokenCIF.split(".")[1]));
				const date = Math.round(new Date() / 1000);
				console.log({ payload });
				console.log({ token: payload.exp, today: date });
				if (payload) {
					const tokenExp = payload.exp;
					if (tokenExp - 60 <= date) {
						getToken(ClientID, dispatch, (newToken) => {
							if (newToken) {
								console.log("sebelum ke depan = ", { newToken });
								cb(newToken);
							}
						});
					} else {
						dispatch({ type: "REQUEST_LP_DONE" });
						cb(tokenCIF);
						console.log("ini token lama = ", tokenCIF);
					}
				} else {
					getToken(ClientID, dispatch, (newToken) => {
						if (newToken) {
							cb(newToken);
							// console.log("sebelum ke depan new = ", {newToken});
						}
					});
				}
			} else {
				getToken(ClientID, dispatch, (newToken) => {
					if (newToken) {
						cb(newToken);
						// console.log("sebelum ke depan new = ", {newToken});
					}
				});
			}
		} catch (err) {
			dispatch({ type: SET_ERROR_STATE, payload: err.message });
		}
	};
const getToken = async (ClientID, dispatch, cb) => {
	try {
		let res = await fetch(`${BASE_URL}${get_token_cif}`, {
			method: "GET",
			credentials: "include",
			headers: {
				"X-Client-ID": ClientID,
				"Content-Type": "application/json",
			},
		});
		let hasil = await res.json();
		// console.log("token cif === ", {res, hasil});
		if (res.status === 200) {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(hasil.result.credential.token);
		} else {
			dispatch({ type: "REQUEST_LP_DONE" });
			cb(null);
			dispatch({ type: SET_ERROR_STATE, payload: hasil.status.message });

			bugsnagClient.notify(new Error(`TokenCIF.js/ (line 71) ==> ${res.status} (${hasil.status.code}) - ${hasil.status.message}`));
		}
	} catch (err) {
		dispatch({ type: "REQUEST_LP_DONE" });
		cb(null);
		dispatch({ type: SET_ERROR_STATE, payload: err.message });
		bugsnagClient.notify(new Error(`TokenCIF.js/ (line 77) ===> catch - ${err.message}`));
	}
};
